module.exports = __webpack_public_path__ + "img/23.8d0a7857.png";